var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ backgroundColor: _vm.bgColor }),attrs:{"id":"inspire"}},[(_vm.loginState)?_c('Navigation'):_vm._e(),(_vm.loginState)?_c('PublicidadOverlay'):_vm._e(),_c('v-main',[_c('v-container',{class:{ 'pa-0': !_vm.loginState },attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }